/** @module utils */

export const hasFeature = (features: string[], feature: string) => {
  return features?.includes(feature);
};
